/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { DidCommMessageSend } from '../../../../types/DidCommMessageSend';

export const DidCommMessageSendRequest: core.serialization.Schema<
    serializers.DidCommMessageSendRequest.Raw,
    Omit<Truvity.DidCommMessageSendRequest, 'idempotencyKey'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    data: DidCommMessageSend,
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace DidCommMessageSendRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        data: DidCommMessageSend.Raw;
        labels?: Record<string, string> | null;
    }
}
